<template>
    <div class="cursor-pointer calendar-icon-wrapper d-inline-flex align-items-center text-theme">
        <VueDatePicker
            v-model="currentDate"
            :is-24="is24"
            :enable-time-picker="timePicker"
            :clearable="false"
            :minutes-grid-increment="minutesGridIncrement"
            :minutes-increment="minutesIncrement"
            :format="format"
            :disabled="disabled"
            :timezone="monthPicker ? undefined : timezone"
            :week-picker="weekPicker"
            :month-picker="monthPicker"
            :auto-apply="autoApply"
            :teleport="true"
        >
            <template #trigger>
                <div class="calendar-icon">
                    <CalendarDays
                        :size="size"
                        :stroke-width="strokeWidth"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        :data-bs-title="title"
                    />
                </div>
            </template>
        </VueDatePicker>
    </div>
</template>
<script>
import {
    CalendarDays
} from 'lucide-vue-next';
export default {
    name: 'CalendarIcon',
    components: {
        CalendarDays
    },
    props: {
        modelValue: {
            default: new Date(),
        },
        minDate: {
            type: Date,
            default: () => new Date(),
        },
        is24: {
            type: Boolean,
            default: false,
        },
        minutesGridIncrement: {
            type: Number,
            default: 10,
        },
        minutesIncrement: {
            type: Number,
            default: 15,
        },
        format: {
            type: String,
            default: 'dd-MM-yyyy',
        },
        clearable: {
            type: Boolean,
            default: false,
        },
        autoApply: {
            type: Boolean,
            default: false,
        },
        timePicker: {
            type: Boolean,
            default: false,
        },
        weekPicker: {
            type: Boolean,
            default: false,
        },
        monthPicker: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        timezone: {
            type: String,
            default: 'UTC',
        },
        size: {
            type: Number,
            default: 24
        },
        strokeWidth: {
            type: Number,
            default: 2
        },
        title: {
            type: String,
            default: 'Select Date'
        }
    },
    data() {
        return {
            currentDate: this.modelValue,
        };
    },
    watch: {
        modelValue(newVal) {
            this.currentDate = newVal;
        },
        currentDate(newVal) {
            this.$emit('update:modelValue', newVal);
        },
    },
}
</script>
<style scoped>
.calendar-icon-wrapper {
    line-height: 0;
    height: 24px;
}

.calendar-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
}

:deep(.dp__input_wrap) {
    width: 24px;
    height: 24px;
    margin: 0;
    padding: 0;
    border: none;
    background: transparent;
}

:deep(.dp__input) {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    border: none;
    opacity: 0;
    cursor: pointer;
}

:deep(.dp__input_icon) {
    display: none;
}
</style>